(function(){
  function labelTables(){
    document.querySelectorAll('table').forEach(function(t){
      var ths=t.querySelectorAll('thead th');
      if(!ths.length) return;
      var labels=[].map.call(ths,function(th){return th.textContent.trim();});
      t.querySelectorAll('tbody tr').forEach(function(tr){
        [].forEach.call(tr.children,function(td,i){ if(labels[i]) td.setAttribute('data-label',labels[i]); });
      });
    });
  }
  function blockZoom(){
    // Disable click-to-zoom lightbox. It opened a dialog stacking ALL gallery
    // images at full size (bag + label crop both huge) which read as broken on mobile.
    document.addEventListener('click', function(e){
      var z = e.target.closest('.product-media-container__zoom-button, .product-media-container--zoomable');
      if(z){ e.preventDefault(); e.stopImmediatePropagation(); }
    }, true);
  }
  function aboutPeople(){
    // Merge the two About people blocks (production team + CEO) into one cohesive
    // section right after the facility section, so people read as a single group.
    var page = document.querySelector('.sr-page--about');
    if(!page) return;
    var teamGrid = page.querySelector('.sr-team-grid:not(.sr-team-grid--leadership)');
    var leadGrid = page.querySelector('.sr-team-grid--leadership');
    if(!teamGrid || !leadGrid) return;
    var teamSection = teamGrid.closest('.sr-section');
    var leadSection = leadGrid.closest('.sr-section');
    if(teamSection) teamSection.classList.add('sr-about-people');
    teamGrid.classList.add('sr-team-grid--3');
    var alexCard = leadGrid.querySelector('.sr-person-card');
    if(alexCard) teamGrid.appendChild(alexCard);
    var promise = leadGrid.querySelector('.sr-card');
    if(promise){ promise.classList.add('sr-about-promise'); teamGrid.parentElement.appendChild(promise); }
    if(leadSection) leadSection.parentNode.removeChild(leadSection);
  }
  function setup(){
    labelTables();
    blockZoom();
    aboutPeople();
    if(location.pathname.indexOf('/products/')===0){ document.body.classList.add('sr-pdp'); }
    var targets=[document.querySelector('footer'), document.querySelector('.sr-footer-chip-row')].filter(Boolean);
    if('IntersectionObserver' in window && targets.length){
      var io=new IntersectionObserver(function(){
        var vh=window.innerHeight||document.documentElement.clientHeight;
        var visible=targets.some(function(t){var r=t.getBoundingClientRect();return r.top < vh && r.bottom > 0;});
        document.body.classList.toggle('sr-footer-visible', visible);
      },{threshold:[0,0.01,0.1]});
      targets.forEach(function(t){io.observe(t);});
    }
  }
  if(document.readyState!=='loading'){ setup(); } else { document.addEventListener('DOMContentLoaded', setup); }
  window.addEventListener('load', labelTables);
})();
